////////LIBRARY/////////
import { find, isUndefined } from 'lodash'
import React from 'react'
import styled from 'styled-components'
///////COMPONENTS///////
import { divisionPicsConfig } from '../../../constants/AssetsPicturesConfigList'

//////STYLED//////
const DivisionColumnWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`
const TextContainer = styled.p`
	margin: 0 5px 0;
	padding: 0;
`
//////STYLED//////

const DivisionColumn = (props) => {
	const f = find(divisionPicsConfig, { id: props.row.companyType.id })

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<DivisionColumnWrapper>
			<img src={`${!isUndefined(f) && f.picture}`} style={{ width: '16px' }} />
			<TextContainer>{props.row.companyType.translationKey.translationKey}</TextContainer>
		</DivisionColumnWrapper>
	)
}

DivisionColumn.propTypes = {}

DivisionColumn.defaultPropTypes = {}

export default DivisionColumn
